import * as React from 'react';
import { RadioButton } from '../../radio-button';
import { IRadioGroupProps, IRadioGroupOption, keyType } from '../radio-group-props';

interface IRadioGroupContentProps extends Pick<IRadioGroupProps, 'onRenderItem' | 'disabled' | 'groupName'> {
    item: IRadioGroupOption;
    isSelected?: boolean;
    onChangeHandler(key: keyType): void;
}

export const RadioGroupContent = React.memo((props: IRadioGroupContentProps) => {
    const { onRenderItem, disabled, item, groupName, onChangeHandler, isSelected } = props;
    const { key, name, title } = item;

    const onSelection = React.useCallback(() => onChangeHandler(key), [onChangeHandler, key]);

    if (onRenderItem) {
        return (
            <>
                {onRenderItem({ isSelected: isSelected, itemData: item, toggleSelection: onSelection, isDisabled: disabled })}
            </>
        );
    }

    return (
        <RadioButton
            checked={isSelected}
            label={name}
            onValueChange={onChangeHandler}
            value={key}
            name={groupName}
            key={key}
            title={title}
            disabled={disabled} />
    );
});

RadioGroupContent.displayName = 'RadioGroupContent';
